
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

export { getNodeName as default };
//# sourceMappingURL=getNodeName.js.map
